import { PlansContainer } from "./Plans.styled";
import { PricingActualPlans } from "../../../interfaces";
import { PlansItem } from "./PlansItem";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";

interface PlansProps {}

export const Plans = observer(({}: PlansProps) => {
	const { pricingActualStore } = useStores();

	const plans = Object.entries(PricingActualPlans);

	return (
		<PlansContainer>
			{plans.map(([key, value], index) => {
				return <PlansItem key={key} title={value} isActive={pricingActualStore.plans === value} value={index + 1} />;
			})}
		</PlansContainer>
	);
});
